// ...existing code...
// 机场存储容量：总容量（单位：KB）、已使用（单位：KB）
export interface AirportStorage {
  total: number, // 单位：KB
  used: number
}

// 舱盖状态
export enum CoverStateEnum {
  Close = 0, // 关闭
  Open = 1, // 打开
  HalfOpen = 2, // 半打开
  Failed = 3 // 失败
}

// 推杆状态
export enum PutterStateEnum {
  Close = 0, // 关闭
  Open = 1, // 打开
  HalfOpen = 2, // 半打开
  Failed = 3, // 失败
}

// 充电状态
export enum ChargeStateEnum {
  NotCharge = 0, // 空闲
  Charge = 1, // 正在充电
}

export interface DroneChargeState {
  state: ChargeStateEnum,
  capacity_percent: string,
}

// 补光灯状态
export enum SupplementLightStateEnum {
  Close = 0, // 关闭
  Open = 1, // 打开
}

// 机场声光报警状态
export enum AlarmModeEnum {
  CLOSE = 0, // 关闭
  OPEN = 1, // 开启
}

// 电池保养
export enum BatteryStoreModeEnum {
  BATTERY_PLAN_STORE = 1, // 电池计划存储策略
  BATTERY_EMERGENCY_STORE = 2, // 电池待命[应急]存储策略
}

// 飞行器电池保养
export enum DroneBatteryStateEnum {
  NoMaintenanceRequired = 0, // 0-无需保养
  MaintenanceRequired = 1, // 1-待保养
  MaintenanceInProgress = 2, // 2-正在保养
}

export enum DroneBatteryModeEnum {
  CLOSE = 0, // 关闭
  OPEN = 1, // 开启
}

// 4g链路连接状态
export enum FourGLinkStateEnum {
  CLOSE = 0, // 断开
  OPEN = 1, // 连接
}

//  Sdr链路连接状态
export enum SdrLinkStateEnum {
  CLOSE = 0, // 断开
  OPEN = 1, // 连接
}

// 机场的图传链路模式
export enum LinkWorkModeEnum {
  SDR = 0, // sdr模式
  FourG_FUSION_MODE = 1, // 4G融合模式
}

// 机场空调模式
export enum AirConditionerModeEnum {
  IDLE_MODE = 0, // 使机场空调进入空闲模式(关闭制冷、制热或除湿)
  COOLING_MODE = 1, // 使机场空调进入制冷模式
  HEATING_MODE = 2, // 使机场空调进入制热模式
  DEHUMIDIFICATION_MODE = 3, // 使机场空调进入除湿模式(除湿包含制冷除湿及制热除湿，由设备端根据自身所处情况自动化处理，无需用户介入)
}

// 切换的目标卡槽{"1":"实体 SIM 卡","2":"eSIM"}
export enum SIMCardSlotEnum {
  UNKNOWN = 0,
  SIM = 1,
  eSIM = 2,
}

// AI识别开关设置 enum_int  {"0":"关闭","1":"开启"}
export enum AiIdentifySetEnum {
  CLOSE = 0, // 关闭
  OPEN = 1, // 开启
}

// AI跟随开关设置 enum_int{"0":"关闭","1":"开启"}
export enum AiSpotlightZoomSetEnum {
  CLOSE = 0, // 关闭
  OPEN = 1, // 开启
}
// ...existing code...
